import { Injectable } from '@angular/core';
import { PortalFieldConfig } from '@portal/form/data-access';

@Injectable({ providedIn: 'root' })
export class MobileFormConfigService {
  initMobileFieldConfig(args: { label: string; key: { key?: string; areaCode: string; number: string } }): PortalFieldConfig[] {
    return [
      {
        wrappers: ['form-field'],
        expressions: {
          fieldGroupClassName: ({ options }) =>
            options?.formState?.disabled ? 'grid grid-cols-[auto_1fr]' : 'grid grid-cols-[120px_1fr] gap-4',
        },
        resetOnHide: false,
        key: args.key.key,
        props: { label: args.label, required: true, wrapperClass: '!mb-0' },
        fieldGroup: [
          {
            key: args.key.areaCode,
            type: '#mobileAreaCode',
            resetOnHide: false,
            props: { required: true },
          },
          {
            key: args.key.number,
            type: 'input',
            resetOnHide: false,
            props: {
              placeholder: 'eg. 88818181',
              maskConfig: { mask: '0*' },
              required: true,
              maxLength: 15,
            },
          },
        ],
      },
    ];
  }
}
